import { render, staticRenderFns } from "./FileStatistics.vue?vue&type=template&id=4709d5ce&scoped=true"
import script from "./FileStatistics.vue?vue&type=script&lang=js"
export * from "./FileStatistics.vue?vue&type=script&lang=js"
import style0 from "./FileStatistics.vue?vue&type=style&index=0&id=4709d5ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4709d5ce",
  null
  
)

export default component.exports